import React, { Component } from "react";


import '../components/filterpage/AllFilters.css';



export default class EntryPage extends Component {

  // constructor(props) {
  //   super(props);
  // }


  render(){
    return (
      <div className="FilterPage container">

        <div className="row">

          <div className="col-lg-6 col-md-12 col-sm-12">

            <div className="tool-box">
              {/* <div className="tool-box-title">Resources & Templates</div> */}
              <div className="data-standards-table">
                <table>
                  <thead>
                    <tr>
                      <th>Data Standards</th>
                      <th>ImmPort Templates</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><p><a href="https://academic.oup.com/database/article/doi/10.1093/database/baaa016/5818925?guestAccessKey=08d43bb2-c79e-40fd-b807-18faf582b8be&login=false">Study Subject Immune Exposure</a></p></td>
                      <td>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/subjectHumans.xlsx" target="_blank" >Human</a></p>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/subjectAnimals.xlsx" target="_blank">Model organism</a></p>
                      </td>
                    </tr>
                    <tr>
                      <td><p><a href="/flow-cytometry">Flow Cytometry</a></p></td>
                      <td>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/experimentSamples.Flow_Cytometry.xlsx" target="_blank" >Flow Cytometry</a></p>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/FCM_Derived_data.xlsx" target="_blank">Flow Cytometry Results</a></p>
                      </td>
                    </tr>
                    <tr>
                      <td><p><a href="/mass-cytometry">Mass Cytometry/CyToF</a></p></td>
                      <td>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/experimentSamples.CYTOF.xlsx" target="_blank">Mass Cytometry/CYTOF</a></p>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/FCM_Derived_data.xlsx" target="_blank">Mass Cytometry Results</a></p>
                      </td>
                    </tr>
                    <tr>
                      <td><p><a href="/metabolomics-mass-spectrometry">Metabolomics Mass Spectrometry</a></p></td>
                      <td>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/experimentSamples.Mass_Spectrometry_Metabolomics.xlsx" target="_blank">Metabolomics Mass Spectrometry</a></p>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/Mass_Spectrometry_Metabolomic_Results.xlsx" target="_blank">Metabolomics Mass Spectrometry  Results</a></p>
                      </td>
                    </tr>
                    <tr>
                      <td><p><a href="/proteomics-mass-spectrometry">Proteomics Mass Spectrometry</a></p></td>
                      <td>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/experimentSamples.Mass_Spectrometry_Proteomics.xlsx" target="_blank">Proteomics Mass Spectrometry</a></p>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/Mass_Spectrometry_Proteomic_Results.xlsx" target="_blank">Proteomics Mass Spectrometry  Results</a></p>
                      </td>
                    </tr>
                    <tr className="last-row-border">
                      <td><p><a href="/transcription-profiling">Transcription Profiling</a></p></td>
                      <td>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/experimentSamples.Gene_Expression_Array.xlsx" target="_blank">Gene Expression Array</a></p>
                        <p><a href="https://downloads.immport.org/data/upload/templates/excel-templates/experimentSamples.RNA_Sequencing.xlsx" target="_blank">RNA Sequencing</a></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>

          <div className="col-lg-6 col-md-12 col-sm-12">

            <div className="tool-box">
              <div className="tool-box-title">Immune Signature Projects</div>
              <div className="tool-box-content">
                <p>Project 1: <a href="https://immunespace.org/is1.url" target="_blank" rel="noreferrer">https://immunespace.org/is1.url</a></p>
                <p>Project 2: <a href="https://immunespace.org/is2.url" target="_blank" rel="noreferrer">https://immunespace.org/is2.url</a></p>
              </div>
            </div>

          </div>

        </div>

      </div>
    );
  }
}